export default {
  default: () => import("/builds/vozilo/vozilo-web/layouts/default.vue").then(m => m.default || m)
}